document.addEventSelectorListener("click", "form [data-confirm]", function(event, target) {
	let form = target.closest("form");
	event.preventDefault();

	let message = target.dataset.confirm;
	if (confirm(message)) {
		form.submit();
	}
});